// Auto-generated Supabase Storage image URLs
// All images are served from the 'product-images' public bucket
const BASE =
  "https://kbxmhcysmrjpwaegnuof.supabase.co/storage/v1/object/public/product-images";

export const IMG_50_LESS_CO2_EM = `${BASE}/50-less-CO2-em.jpeg`;
export const IMG_CASUAL_CHIC = `${BASE}/Casual%20Chic%20with%20DAINASOUL%20T-shirt.png`;
export const IMG_60_LESS_ENERGY = `${BASE}/60-less-energy.jpeg`;
export const IMG_90_LESS_WATER = `${BASE}/90-less-water.jpeg`;
export const IMG_BEIGE_HOODIE_1 = `${BASE}/Beige-Hoodie-1.png`;
export const IMG_BEIGE_HOODIE_2 = `${BASE}/Beige-Hoodie-2.png`;
export const IMG_DAINASOUL_FINAL = `${BASE}/DAINASOUL-FINAL.jpeg`;
export const IMG_DAINASOUL_HOODIE_BACK_BALI = `${BASE}/DAINASOUL-Hoodie-Back-Bali.png`;
export const IMG_DAINASOUL_HOODIE_BACK_BANGKOK = `${BASE}/DAINASOUL-Hoodie-Back-Bangkok.png`;
export const IMG_DAINASOUL_HOODIE_BACK_CANADA = `${BASE}/DAINASOUL-Hoodie-Back-Canada.png`;
export const IMG_DAINASOUL_HOODIE_BLACK_2 = `${BASE}/DAINASOUL-Hoodie-Black-2.png`;
export const IMG_DAINASOUL_HOODIE_BLACK_3 = `${BASE}/DAINASOUL-Hoodie-Black-3.jpeg`;
export const IMG_DAINASOUL_HOODIE_HANG = `${BASE}/DAINASOUL-Hoodie-Hang.png`;
export const IMG_DAINASOUL_HOODIE_PINK_GIRL = `${BASE}/DAINASOUL-Hoodie-Pink-Girl.png`;
export const IMG_DAINASOUL_HOODIE_PINK_OLD_LADY = `${BASE}/DAINASOUL-Hoodie-Pink-Old-Lady.png`;
export const IMG_DAINASOUL_HOODIE_SMALL_LOGO = `${BASE}/DAINASOUL-Hoodie-Small-Logo.png`;
export const IMG_DAINASOUL_HOODIE_WHITE_2 = `${BASE}/DAINASOUL-Hoodie-White-2.png`;
export const IMG_DAINASOUL_MAIN_IMAGE = `${BASE}/DAINASOUL-Main-Image.png`;
export const IMG_DAINASOUL_PINK_HOODIE_NEW = `${BASE}/DAINASOUL-Pink-Hoodie-New.png`;
export const IMG_DAINASOUL_WALLPAPER_HOODIE = `${BASE}/DAINASOUL-Wallpaper-Hoodie.png`;
export const IMG_DAINASOUL_WALLPAPER = `${BASE}/DAINASOUL-Wallpaper.jpeg`;
export const IMG_DAINASOUL_BLACK_WHITE = `${BASE}/Dainasoul-Black-White.png`;
export const IMG_DAINASOUL_HOODIE_SMALL_LOGO_2 = `${BASE}/Dainasoul-Hoodie-Small-Logo-2.png`;
export const IMG_DAINASOUL_IMG = `${BASE}/Dainasoul-IMG.jpeg`;
export const IMG_DAINASOUL_IMG1 = `${BASE}/Dainasoul-IMG1.jpeg`;
export const IMG_DAINASOUL_IMG2 = `${BASE}/Dainasoul-IMG2.jpeg`;
export const IMG_DAINASOUL_IMG3 = `${BASE}/Dainasoul-IMG3.jpg`;
export const IMG_DAINASOUL_LOGO_NEW = `${BASE}/Dainasoul-og.png`;
export const IMG_DAINASOUL_SMALL_LOGO_NEW = `${BASE}/Dainasoul-Small-Logo-New.jpeg`;
export const IMG_DAINASOUL_STORE = `${BASE}/Dainasoul-Store.png`;
export const IMG_DAINASOUL_TONAL_CREAM = `${BASE}/Dainasoul-Tonal-Cream.png`;
export const IMG_DAINASOUL_NEW_NO_BACKGROUND = `${BASE}/Dainasoul-new-no-background.png`;
export const IMG_DAINASOUL_NEW = `${BASE}/Dainasoul-new.png`;
export const IMG_GOTS_HANG_TAG = `${BASE}/GOTS-Hang-Tag.png`;
export const IMG_HOME_WALLPAPER_NEW = `${BASE}/Home-Wallpaper-New.png`;
export const IMG_HOODIE_BEIGE_RED_1 = `${BASE}/Hoodie-Beige-Red-1.png`;
export const IMG_HOODIE_BLACK_01 = `${BASE}/Hoodie-Black-01.png`;
export const IMG_HOODIE_BLACK_RED_1 = `${BASE}/Hoodie-Black-Red-1.png`;
export const IMG_HOODIE_BLACK_RED_MAIN = `${BASE}/Hoodie-Black-Red-Main.png`;
export const IMG_HOODIE_BLACK_RED_WALLPAPER = `${BASE}/Hoodie-Black-Red-Wallpaper.png`;
export const IMG_HOODIE_BLUE_01 = `${BASE}/Hoodie-Blue-01.png`;
export const IMG_HOODIE_BLUE_2 = `${BASE}/Hoodie-Blue-2.png`;
export const IMG_HOODIE_BLUE_SMALL_LOGO_01 = `${BASE}/Hoodie-Blue-Small-Logo-01.png`;
export const IMG_HOODIE_PINK_01 = `${BASE}/Hoodie-Pink-01.png`;
export const IMG_HOODIE_PINK_3 = `${BASE}/Hoodie-Pink-3.png`;
export const IMG_HOODIE_PINK_BACKGROUND = `${BASE}/Hoodie-Pink-Background.jpeg`;
export const IMG_HOODIE_SIZE_CHART = `${BASE}/Hoodie-Size-Chart.png`;
export const IMG_HOODIE_WHITE_01 = `${BASE}/Hoodie-White-01.png`;
export const IMG_HOODIE_WHITE_1 = `${BASE}/Hoodie-White-1.png`;
export const IMG_HOODIE_WHITE_RED_1 = `${BASE}/Hoodie-White-Red-1.png`;
export const IMG_ICON_UNISEX_38X = `${BASE}/ICON_Unisex_38x.jpeg`;
export const IMG_LOGO_BLACK = `${BASE}/Logo-Black.png`;
export const IMG_LOGO_NEW = `${BASE}/Logo-New.png`;
export const IMG_LOGO = `${BASE}/Logo.PNG`;
export const IMG_ORGANIC_COTTON_IMAGE = `${BASE}/Organic-Cotton-Image.jpeg`;
export const IMG_OUR_MISSION_IMAGE = `${BASE}/Our-Mission-Image.jpeg`;
export const IMG_PILLOW1 = `${BASE}/Pillow1.jpeg`;
export const IMG_PILLOW2 = `${BASE}/Pillow2.jpeg`;
export const IMG_PILLOW3 = `${BASE}/Pillow3.jpeg`;
export const IMG_PILLOW4 = `${BASE}/Pillow4.jpeg`;
export const IMG_SIZE_CHART_IMAGE = `${BASE}/Size-Chart-Image.jpg`;
export const IMG_SIZE_ICON = `${BASE}/SizeIcon.png`;
export const IMG_SWEATSHIRT_BLACK_MAIN = `${BASE}/Sweatshirt-Black-Main.png`;
export const IMG_SWEATSHIRT_BLACK = `${BASE}/Sweatshirt-Black.png`;
export const IMG_WALLPAPER1 = `${BASE}/Wallpaper1.jpeg`;
export const IMG_BAUMWOLLE_ICON = `${BASE}/baumwolle-icon.png`;
export const IMG_DAINASOUL_TSHIRT1 = `${BASE}/dainasoul-tshirt1.png`;
export const IMG_DAINASOUL_TSHIRT2 = `${BASE}/dainasoul-tshirt2.png`;
export const IMG_DAINASOUL_TSHIRT3 = `${BASE}/dainasoul-tshirt3.png`;
export const IMG_DAINASOUL_TSHIRT4 = `${BASE}/dainasoul-tshirt4.png`;
export const IMG_DAINASOUL_TSHIRT5 = `${BASE}/dainasoul-tshirt5.png`;
export const IMG_EARRING_FROST1 = `${BASE}/earring-frost1.jpeg`;
export const IMG_EARRING_FROST2 = `${BASE}/earring-frost2.jpg`;
export const IMG_EARRING_FROST3 = `${BASE}/earring-frost3.jpg`;
export const IMG_EARRING_FROST4 = `${BASE}/earring-frost4.jpg`;
export const IMG_EARRING_FROST5 = `${BASE}/earring-frost5.jpg`;
export const IMG_EARRING_FROST6 = `${BASE}/earring-frost6.jpg`;
export const IMG_ICON_SHIPPING = `${BASE}/icon-shipping.jpeg`;
export const IMG_MASTER = `${BASE}/master.svg`;
export const IMG_NECKALCE_FEATHER1 = `${BASE}/neckalce-feather1.jpg`;
export const IMG_NECKALCE_FEATHER2 = `${BASE}/neckalce-feather2.jpg`;
export const IMG_NECKALCE_FEATHER3 = `${BASE}/neckalce-feather3.jpg`;
export const IMG_NECKALCE_FEATHER4 = `${BASE}/neckalce-feather4.jpg`;
export const IMG_NECKALCE_FEATHER5 = `${BASE}/neckalce-feather5.jpg`;
export const IMG_NECKALCE_FEATHER6_BG_REMOVED = `${BASE}/neckalce-feather6%20Background%20Removed.png`;
export const IMG_NECKALCE_FEATHER6 = `${BASE}/neckalce-feather6.jpg`;
export const IMG_PAYPAL_ICON = `${BASE}/paypal-icon.png`;
export const IMG_RUPAY = `${BASE}/rupay.svg`;
export const IMG_SILVER_EARRINGS = `${BASE}/silver-earrings.png`;
export const IMG_SILVER_NECKLACE = `${BASE}/silver-necklace.png`;
export const IMG_SPULE = `${BASE}/spule.jpeg`;
export const IMG_UPI = `${BASE}/upi.svg`;
export const IMG_VISA = `${BASE}/visa.svg`;

export const IMG_TSHIRT_BEIGE_BACK = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Back.png`;
export const IMG_TSHIRT_BEIGE_LOGO_BLACK_BOY = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Black%20Boy.png`;
export const IMG_TSHIRT_BEIGE_LOGO_BLACK_GIRL = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Black%20Girl.png`;
export const IMG_TSHIRT_BEIGE_LOGO_BLACK = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Black.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_BOY = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Red%20Boy.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_GIRL1 = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Red%20Girl%201.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_GIRL2 = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Red%20Girl%202.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED_GIRL3 = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Red%20Girl%203.png`;
export const IMG_TSHIRT_BEIGE_LOGO_RED = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20Red.png`;
export const IMG_TSHIRT_BEIGE_LOGO_WHITE_BOY = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20White%20Boy.png`;
export const IMG_TSHIRT_BEIGE_LOGO_WHITE_GIRL = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20White%20Girl.png`;
export const IMG_TSHIRT_BEIGE_LOGO_WHITE = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Logo%20White.png`;
export const IMG_TSHIRT_BEIGE_WITHOUT_LOGO_BOY = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Without%20Logo%20Boy.png`;
export const IMG_TSHIRT_BEIGE_WITHOUT_LOGO_GIRL = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Without%20Logo%20Girl.png`;
export const IMG_TSHIRT_BEIGE_WITHOUT = `${BASE}/DAINASOUL%20T-Shirt%20Beige%20Without.png`;
export const IMG_DAINASOUL_CAP_CREAM = `${BASE}/DAINASOUL%20Cap%20Cream.png`;
export const IMG_DAINASOUL_TERRY_SHORTS_RED = `${BASE}/DAINASOUL%20Terry%20Shorts%20Red.png`; 
export const IMG_DAINASOUL_CANVAS_TOTE_BLACK = `${BASE}/DAINASOUL%20Canvas%20Tote%20Black.png`;
export const IMG_DAINASOUL_HOME_PAGE_IMAGE_BEIGE = `${BASE}/DAINASOUL%20Home%20Page%20Image%20Beige.png`;
export const IMG_DAINASOUL_HOME_PAGE_IMAGE_BLACK = `${BASE}/DAINASOUL%20Home%20Page%20Image%20Black.png`;
export const IMG_DAINASOUL_HOME_PAGE_IMAGE_GRAY = `${BASE}/DAINASOUL%20Home%20Page%20Image%20Gray.png`;
export const IMG_DAINASOUL_HOME_PAGE_IMAGE_GRAY_MOBILE = `${BASE}/DAINASOUL%20Home%20Page%20Image%20Gray%20Mobile.png`;
export const IMG_SIZE_CHART_TSHIRT = `${BASE}/Size%20Chart%20Tshirt.png`;
